import { getBaseUrl } from "./api-config";

const baseUrl = getBaseUrl();

export const API_ENDPOINTS = {
  user: {},
  driver: {
    deleteDriver: `${baseUrl}/driver/api/driver`,
    addDriver: `${baseUrl}/driver/api/drivers`,
    editDriver: `${baseUrl}/driver/api/driver`,
    assignSubcriptionToDriver: `${baseUrl}/driver/api/assignSubcriptionToDriver`,
    assignBatteries: `${baseUrl}/driver/api/driver`,
    getAllDriverData: `${baseUrl}/driver/api/drivers`,
    getListOfDriverNames: `${baseUrl}/driver/api/drivers/getListOfDriverNames`,
    getAllDrivers: `${baseUrl}/driver/api/drivers`,
    getListOfDriverIds: `${baseUrl}/driver/api/drivers/getListOfDriverIds`,
    getDriverDetails: `${baseUrl}/driver/api/drivers/getDriverDetailsByDriverUid`,
    getSingleDriverData: `${baseUrl}/driver/api/drivers`,
    getBatteries: `${baseUrl}/driver/api/driver/getBatteries`,
    getDriverDetailsByDriverId: `${baseUrl}/driver/api/drivers/getDriverDetailsByDriverId`,
    getDriverDeatilsByDriverName: `${baseUrl}/driver/api/drivers/getDriverDeatilsByDriverName`,
    createSubscriptionPlanPackage: `${baseUrl}/driver/api/createSubscriptionPlanPackage`,
    updateSubscriptionPlanPackage: `${baseUrl}/driver/api/updateSubscriptionPlanPackage`,
    getSubscriptionPlanPackages: `${baseUrl}/driver/api/getSubscriptionPlanPackages`,
    getSubscriptionPlanPackageById: `${baseUrl}/driver/api/getSubscriptionPlanPackageById`,
    deleteSubscriptionPlanPackage: `${baseUrl}/driver/api/deleteSubscriptionPlanPackage`,
    getSubscriptionPlanPackageIdsAndName: `${baseUrl}/driver/api/getSubscriptionPlanPackageIdsAndName`,
    assignSubscriptionPlanPackageToDriver: `${baseUrl}/driver/api/assignSubscriptionPlanPackageToDriver`,
    getSubscriptionPlanPackageAssignedDrivers: `${baseUrl}/driver/api/getSubscriptionPlanPackageAssignedDrivers`,
    getSubscriptionPlanPackageAssignmentLogs: `${baseUrl}/driver/api/getSubscriptionPlanPackageAssignmentLogs`,
  },
  battery: {
    getAllBatteriesAvailable: `${baseUrl}/battery/api/batteries/getAllBatteriesAvailable`,
    getListOfBatteries: `${baseUrl}/battery/api/batteries/getListOfBatteries`,
    searchBatteryByBatteryId: `${baseUrl}/battery/api/batteries/searchBatteryByBatteryId`,
    getAllBatteriesData: `${baseUrl}/battery/api/batteries/getAllBatteriesData`,
    changeBatteryStatus: `${baseUrl}/battery/api/batteries/changeBatteryStatus`,
  },
  charger: {
    assignCharger: `${baseUrl}/charger/api/assignCharger`,
    createCharger: `${baseUrl}/charger/api/createCharger`,
    getAllChargers: `${baseUrl}/charger/api/getAllChargers`,
    getListOfChargerIds: `${baseUrl}/charger/api/getListOfChargerIds`,
    getChargerAssignmentLogs: `${baseUrl}/charger/api/getChargerAssignmentLogs`,
    updateCharger: `${baseUrl}/charger/api/updateCharger`,
    deleteCharger: `${baseUrl}/charger/api/deleteCharger`,
  },
  station: {},
  general: {
    getPaymentList: `${baseUrl}/general/api/general/getPaymentTransactions`,
    getListOfPartnerIds: `${baseUrl}/general/api/general/getListOfPartnerIds`,
    getAllBills: `${baseUrl}/general/api/general/getAllBills`,
    getSwapLogsBaas:`${baseUrl}/general/api/general/getSwapLogsBaas`,
    getDeviceIds:`${baseUrl}/general/api/general/getDeviceIds`,
    subscriptionPlanDriverLogs:`${baseUrl}/general/api/subscriptionPlanDriverLogs`,
    subscriptionPlanFilterOption:`${baseUrl}/general/api/subscriptionPlanFilterOption`,
    subscriptionPlan:`${baseUrl}/general/api/subscriptionPlan`,
    getAllStationsData:`${baseUrl}/general/api/general/getAllStationsData`,
    getDriverOrgs:`${baseUrl}/general/api/general/getDriverOrgs`,
    getSubscriptionPlanByPlanId:`${baseUrl}/general/api/getSubscriptionPlanByPlanId`,
    getCities:`${baseUrl}/general/api/getCities`,
  },
  payment: {},
  swap: {},
  subscription: {},
};